import { render, staticRenderFns } from "./add-to-watch-list.vue?vue&type=template&id=b75bb19c"
import script from "./add-to-watch-list.vue?vue&type=script&lang=js"
export * from "./add-to-watch-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports